module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showLoading) ? _c('div', {
    staticClass: "pg-loading-screen",
    class: _vm.showScreen ? 'pg-loading-screen-show' : ''
  }, [_c('div', {
    staticClass: "pg-loading-center-outer"
  }, [_c('div', {
    staticClass: "pg-loading-center-middle"
  }, [_c('div', {
    staticClass: "pg-loading-html",
    class: _vm.showMessage ? 'pg-loading-html-show' : ''
  }, [_c('p', {
    staticClass: "loading-message"
  }, [_vm._v(_vm._s(_vm.message))])])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d928899","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/modules/Loading/Loading.vue
// module id = 329
// module chunks = 0